import React, { useEffect } from 'react'
import { Dialog, DialogTitle } from '@headlessui/react'

const AUTO_DISMISS_MS = 3000

// success messages auto-dismiss as a toast so they don't interrupt the flow;
// everything else (errors, validation) stays a blocking dialog since it
// usually needs to be read and acted on before continuing.
const ResponseDialog = ({ open, onClose, responseMessage, severity = 'error' }) => {
    const isSuccess = severity === 'success'

    useEffect(() => {
        if (!open || !isSuccess) return undefined
        const timer = setTimeout(onClose, AUTO_DISMISS_MS)
        return () => clearTimeout(timer)
    }, [open, isSuccess, onClose])

    if (!open) {
        return null
    }

    if (isSuccess) {
        return (
            <div className="fixed top-4 right-4 left-4 sm:left-auto z-50 sm:w-full sm:max-w-sm">
                <div className="card-surface bg-white p-4 flex items-start gap-3">
                    <span className="badge-success shrink-0">Success</span>
                    <p className="text-sm text-gray-700 flex-1">{responseMessage}</p>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 shrink-0"
                        aria-label="Dismiss"
                    >
                        ✕
                    </button>
                </div>
            </div>
        )
    }

    return (
        <Dialog open={open} onClose={onClose} className="fixed inset-0 z-50">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4">
                <div className="w-full max-w-md bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
                    <DialogTitle className="text-xl font-semibold text-gray-900">Response</DialogTitle>
                    <div className="mt-2 text-base text-gray-600">{responseMessage}</div>
                    <div className="mt-4 flex justify-end">
                        <button className="btn-primary" onClick={onClose}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default ResponseDialog
